import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@common/components/ConfirmDialog';

type Props = {
  open: boolean;
  runName: string;
  confirmation? : string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteConfirmDialog({ open, runName, confirmation, onConfirm, onCancel }: Props) {
  const { t } = useTranslation('interface');

  return (
    <ConfirmDialog
      open={open}
      title={t('simulation.delete_dialog.title', { runName })}
      confirmation={confirmation}
      content={t('simulation.delete_dialog.content')}
      yesLabel={t('simulation.delete_dialog.yes_button.label')}
      noLabel={t('simulation.delete_dialog.no_button.label')}
      onConfirm={onConfirm}
      onDecline={onCancel}
    />
  );
}
